module.exports = __webpack_public_path__ + "static/media/water.19fbf6bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/game/assets/board/water.png
// module id = 65
// module chunks = 0